import React, { useMemo } from 'react';
import { AutocompleteSelect, type AutocompleteOption } from './AutocompleteSelect';
import * as countriesLib from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

// Register English locale once
countriesLib.registerLocale(enLocale);

interface AddressCountrySelectProps {
  value?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const AddressCountrySelect: React.FC<AddressCountrySelectProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const countryOptions: AutocompleteOption[] = useMemo(() => {
    const names = countriesLib.getNames('en');
    return Object.entries(names)
      .map(([code, name]) => ({ value: name as string, label: name as string }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, []);

  return (
    <AutocompleteSelect
      value={value}
      onChange={onChange}
      options={countryOptions}
      placeholder="Select country..."
      searchPlaceholder="Search countries..."
      emptyText="No country found."
      creatable
      disabled={disabled}
    />
  );
};

export { AddressCountrySelect };
